/* global gtag */

import Vue from "vue";
import Router from "vue-router";

import Home from "./components/Home.vue";

Vue.use(Router);

const router = new Router({

    scrollBehavior() {

        return { x: 0, y: 0 };

    },

    routes: [

        {
            path: "/",
            name: "Home",
            component: Home
        },

        {
            path: "/catalogo",
            name: "catalogo",
            component: () => import("./components/Catalogo.vue")
        },

        {
            path: "/flippingbook",
            name: "flippingbook",
            component: () => import("./components/Flippingbook.vue")
        }

    ],

    mode: "history"

});

router.afterEach((to) => {

    if (typeof gtag === "function") {

        gtag("config", "G-3ZTCQ1SYZ8", {
            page_path: to.fullPath
        });

    }

});

export default router;